import { Ability } from '@casl/ability';
import { once } from 'ramda';
import { abilitiesPlugin } from '@casl/vue';
import Vue from 'vue';

const rulesProviders = new Map();
const ability = new Ability();

Vue.use(abilitiesPlugin, ability);

const rebuild = () => {
	const combinedRules = [];

	for (const rules of rulesProviders.values())
		combinedRules.push(...rules);

	ability.update(combinedRules);
}

let resolver

/** @type { Promise<import('@casl/ability').Ability> } */
export const getAbilityPromise = new Promise((resolve) => {
	resolver = resolve
})

export const getAbility = once((key, rules) => {
	rulesProviders.set(key, rules);
	rebuild();
	resolver(ability);
	return ability;
})

export const extend = (key, rules) => {
	rulesProviders.set(key, rules);
	rebuild();
}
